module.exports = __webpack_public_path__ + "/bundle/asset/about-ef5cd4927e9dd397a8c7b873b9f75228.png";